import {backendUrl} from '@config';
import moment from 'moment';

/* eslint-disable one-var */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-bitwise */
// based on https://awik.io/determine-color-bright-dark-using-javascript/

export const lightOrDark = color => {
  // Variables for red, green, blue values
  let r, g, b;

  // Check the format of the color, HEX or RGB?
  if (color.startsWith('rgb')) {
    // If RGB --> store the red, green, blue values in separate variables
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    color = +`0x${color.slice(1).replace(color.length < 5 && /./g, '$&$&')}`;

    r = color >> 16;
    g = color >> 8 & 255;
    b = color & 255;
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 200) {
    return 'light';
  }

  return 'dark';
};

/* eslint-enable one-var */
/* eslint-enable no-param-reassign */
/* eslint-enable prefer-destructuring */
/* eslint-enable no-bitwise */

// gets the full url for an image, possibly prepending the backend-url if the url is absolute
export const getImageUrl = src => {
  if (!src) {
    return '';
  }
  if (src.startsWith(backendUrl)) {
    return src;
  }
  if (src.charAt(0) === '/') {
    return backendUrl + src;
  }

  return src;
};

export const removeHTML = (str, keepLine = true) => {
  var tmp = document.createElement('DIV');

  if (keepLine) {
    tmp.innerHTML = str.replace('<br />', '[br]');

    return (tmp.textContent || tmp.textContent || '').replace('[br]', '<br />');
  }else {
    tmp.innerHTML = str;

    return tmp.textContent || tmp.textContent || '';
  }
};

export const getAccess = (orgAccess, userAccess) => {
  const access = {
    onboarding: false,
    learning: false,
    userAccess: userAccess && userAccess || 'crew',
    gathering: false,
    users: 20,
    maps: 5,
    learingportal: false,
  };


  if (orgAccess.length === 4) {
    access.onboarding = orgAccess[0] === '1' && true || false;
    orgAccess = orgAccess.slice(1);
  }

  if (orgAccess.length === 3) {
    access.learning = orgAccess[0] === '1' && true || false;
    orgAccess = orgAccess.slice(1);
  }

  if (orgAccess.length === 2) {
    access.meeting = orgAccess[0] === '1' && true || false;
    access.learingportal = orgAccess[0] === '2' && true || false;
    orgAccess = orgAccess.slice(1);
  }

  if (orgAccess.length === 1 && orgAccess[0] === '3') {
    access.users = 200;
  }else if (orgAccess.length === 1 && orgAccess[0] === '2') {
    access.users = 50;
  }

  return access;
};

// given a html-node, return all the parents of this node as a list, excuding the document-element
export const  parentsForHtmlNode = node => {
  if(!node) {
    return [];
  }
  let current = node;
  const list = [];

  while(current.parentNode != null && current.parentNode !== document.documentElement) {
    list.push(current.parentNode);
    current = current.parentNode;
  }

  return list;
};

export const getTwoletterLangCodeFromNavigatorLanguage = () => {
  const navLang = navigator.language && navigator.language.toLocaleLowerCase();

  if(!navLang) {
    return null;
  }

  if(navLang.startsWith('en-')) {
    return 'en';
  }

  return {
    'nb-no':'no',
    'nn-no':'no',
  }[navLang] || 'no';
};

export const emptyDate = () => {
  const d = new Date();

  d.setMilliseconds(0);
  d.setMinutes(0);
  d.setSeconds(0);
  d.setHours(0);
  d.setFullYear(0);
  d.setMonth(0);
  d.setDate(1);

  return d;
};

// https://stackoverflow.com/a/44198641
export const isValidDate = date =>
  date
  && Object.prototype.toString.call(date) === '[object Date]'
  && !Number.isNaN(date);

export const lastDateThisYear = () => {
  const d = new Date();

  d.setMonth(11);
  d.setDate(31);
  d.setHours(23, 59, 59);

  return d;
};

export const verifyPassed = competence => {
  if (competence.passed === 100 && competence.valid_until && moment(competence.valid_until, 'DD.MM.YYYY').isBefore(moment())) {
    return false;
  }

  return competence.passed === 100;
};

export const lastDateNextYear = () => {
  const d = lastDateThisYear();

  d.setFullYear(d.getFullYear() + 1);

  return d;
};

export const addifNotExistsUsingKey = (arr, elem, key) => {
  if(!arr.some(e => e[key] === elem[key])) {
    return [...arr, elem];
  }

  return arr;
};

export const addifNotExists = (arr, elem) => {
  if(!arr.includes(elem)) {
    return [...arr, elem];
  }

  return arr;
};

export const removeDuplicatesUsingKey = (arr, key) => {
  const res = [];

  for(const elem of arr) {
    if(!res.some(r => r[key] === elem[key])) {
      res.push(elem);
    }
  }

  return res;
};

export const daysDifference = (dateMax, dateMin) => {
  const ms = 1000 * 3600 * 24;
  const difference = dateMax.getTime() - dateMin.getTime();

  return difference / ms;
};

export const verifyDeadlines = event => {
  const {
    sign_off_deadline,
    sign_on_deadline,
  } = event;

  const now = new Date();

  const signOnDeadline = new Date(sign_on_deadline);
  const signOffDeadline = new Date(sign_off_deadline);

  const enableSignOn = signOnDeadline > now;
  const enableSignOff = signOffDeadline > now;

  const daysToSignOn = enableSignOn ? daysDifference(signOnDeadline, now) : 0;
  const daysToSignOff =  enableSignOff ? daysDifference(signOffDeadline, now) : 0;

  return {
    signOnDeadline,
    signOffDeadline,
    enableSignOn,
    enableSignOff,
    daysToSignOn,
    daysToSignOff,
  };
};



export const verifyDeadlineDates = (signOnDeadlineDate, signOffDeadlineDate)  => {
  const now = new Date();

  const enableSignOn = signOnDeadlineDate > now;
  const enableSignOff = signOffDeadlineDate > now;

  const daysToSignOn = enableSignOn ? daysDifference(signOnDeadlineDate, now) : 0;
  const daysToSignOff =  enableSignOff ? daysDifference(signOffDeadlineDate, now) : 0;

  return {
    signOnDeadline: signOnDeadlineDate,
    signOffDeadline: signOffDeadlineDate,
    enableSignOn,
    enableSignOff,
    daysToSignOn,
    daysToSignOff,
  };
};
